export default __webpack_public_path__ + "static/media/ic_mas.f0c08b55.svg";